import axios from 'axios';
import humps from 'humps';
import OMSError from './error';
const createRequest = (config) => {
    const headers = {
        'Content-Type': 'application/json',
    };
    if (config.storeSlug) {
        headers['ACS-Store'] = config.storeSlug;
    }
    const client = axios.create({
        baseURL: config.domain,
        headers,
    });
    client.interceptors.response.use((response) => {
        if (response?.data) {
            response.data = humps.camelizeKeys(response.data);
        }
        return response;
    }, (error) => {
        if (error.response?.data) {
            /* eslint-disable-next-line no-param-reassign */
            error.response.data = humps.camelizeKeys(error.response.data);
        }
        const message = error.toString();
        const status = error.response?.status;
        const data = error.response?.data;
        return Promise.reject(new OMSError(message, status, data));
    });
    client.interceptors.request.use((request) => {
        if (request?.data) {
            request.data = humps.decamelizeKeys(request.data);
        }
        if (request?.config?.params) {
            request.config.params = humps.decamelizeKeys(request.config.params);
        }
        return request;
    }, (error) => {
        return Promise.reject(error);
    });
    return client;
};
export default createRequest;
